import LocationsCompareNative from "./LocationsCompareNative"
import { AuthorizationProvider } from '../../lib/use-authorization'

function LocationsCompareWrapper(props) {
  const { permissions } = props
  
  return (
    <AuthorizationProvider initialPermissions={permissions}>
      <LocationsCompareNative {...props}/>
    </AuthorizationProvider>
  )
}

export default LocationsCompareWrapper
